import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { Plus, Edit2 } from 'lucide-react';

const CustomerFormDialog = ({
  open, onOpenChange, editingCustomer, customerFormData, setCustomerFormData,
  handleSaveCustomer, saving,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          {editingCustomer ? <Edit2 className="h-5 w-5" /> : <Plus className="h-5 w-5" />}
          {editingCustomer ? 'Edit Customer' : 'Add Customer'}
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <Label>Name *</Label>
          <Input value={customerFormData.name} onChange={(e) => setCustomerFormData({ ...customerFormData, name: e.target.value })} placeholder="Customer name" className="mt-1" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Email</Label><Input type="email" value={customerFormData.email} onChange={(e) => setCustomerFormData({ ...customerFormData, email: e.target.value })} placeholder="email@example.com" className="mt-1" /></div>
          <div><Label>Phone</Label><Input type="tel" value={customerFormData.phone} onChange={(e) => setCustomerFormData({ ...customerFormData, phone: e.target.value })} placeholder="+1 234 567 8900" className="mt-1" /></div>
        </div>
        <div><Label>Address</Label><Input value={customerFormData.address} onChange={(e) => setCustomerFormData({ ...customerFormData, address: e.target.value })} placeholder="Street, City, Country" className="mt-1" /></div>
        <div><Label>Notes</Label><Textarea value={customerFormData.notes} onChange={(e) => setCustomerFormData({ ...customerFormData, notes: e.target.value })} placeholder="Any notes about this customer..." className="mt-1" rows={2} /></div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={handleSaveCustomer} disabled={saving} className="bg-blue-600 hover:bg-blue-700">
            {saving ? 'Saving...' : editingCustomer ? 'Update' : 'Add Customer'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default CustomerFormDialog;
